import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {catchError, map, takeUntil} from 'rxjs/operators';
import {BaseService} from './base.service';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({providedIn: 'root'})
export class BlogService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    list(params: any = {}): Observable<any> {
        return this.getRequest(AppUrl.BLOGS(), params);
    }

    detail(id: number | string): Observable<any> {
        return this.getRequest(AppUrl.BLOG(id));
    }

    create(form: FormData): Observable<any> {
        return this.postForm(AppUrl.BLOGS(), form);
    }

    update(id: number | string, form: FormData): Observable<any> {
        return this.postForm(AppUrl.BLOG(id), form);
    }

    remove(id: number | string): Observable<any> {
        return this.deleteRequest(AppUrl.BLOG(id));
    }

    uploadContentImage(file: File): Observable<any> {
        const form = new FormData();
        form.append('image', file);
        return this.postForm(AppUrl.BLOG_UPLOAD_IMAGE(), form);
    }

    /**
     * Multipart upload helper. We deliberately set a Content-Type header so the global
     * interceptor strips it, letting Angular populate the multipart boundary correctly.
     */
    private postForm(url: string, body: FormData): Observable<any> {
        const headers = new HttpHeaders({'Content-Type': 'multipart/form-data'});
        return this.http.post(url, body, {headers}).pipe(
            takeUntil(this.globalService.isSessionExist),
            map((res: any) => {
                if (res && res.message) {
                    this.alertService.showSuccess({title: 'Success', message: res.message});
                }
                return res ? res.data : null;
            }),
            catchError((err: HttpErrorResponse) => this.handleError(err))
        );
    }
}
